export default "__VITE_ASSET__B$OdTHuS__"